import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from '../_FindAnIndependantFinancialAdviser.scss'
import * as commonStyles from '../../../common/_common.scss'
import { Form, Radio, Row, Col } from 'react-bootstrap'
import ResponsiveInputsList from '../../../common/forms/ResponsiveInputsList'
import FieldGroup from '../../../common/forms/FieldGroup'
import { inputFormatToRands } from '../../../common/formatters'

const helpBlockStyles = styles['help-block-font-size'] +
  ' ' + styles['margin-left-auto'] +
  ' ' + styles['margin-right-auto'] +
  ' ' + 'alert alert-danger'

class InvestmentAmount extends React.Component {
  static propTypes = {
    knowsHowMuchToInvestOptions: PropTypes.array.isRequired,
    knowsHowMuchToInvestSelected: PropTypes.func.isRequired,
    selectedKnowsHowMuchToInvestOptionId: PropTypes.number,

    investmentAmounts: PropTypes.object.isRequired,
    monthlyInvestmentAmountSelected: PropTypes.func.isRequired,
    onceOffInvestmentAmountSelected: PropTypes.func.isRequired,
    onChange: PropTypes.func,

    validation: PropTypes.object.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
  }

  constructor (props) {
    super(props)

    this.state = { isEditingMonthlyInvestment: false }
    this.state = { isEditingOnceOffInvestment: false }

    this.onKnowsHowMuchToInvestOptionStateChange = this.onKnowsHowMuchToInvestOptionStateChange.bind(this)
    this.onMonthlyChanged = this.onMonthlyChanged.bind(this)
    this.onOnceOffChanged = this.onOnceOffChanged.bind(this)
    this.toggleEditingMonthlyInvestment = this.toggleEditingMonthlyInvestment.bind(this)
    this.toggleEditingOnceOffInvestment = this.toggleEditingOnceOffInvestment.bind(this)
    this.onOnceOffChanged = this.onOnceOffChanged.bind(this)
    this.renderKnowsHowMuchToInvestmentOptionRadioButton = this.renderKnowsHowMuchToInvestmentOptionRadioButton.bind(this)
  }

  onKnowsHowMuchToInvestOptionStateChange = (event) => {
    let knowsHowMuchToInvestOptionId = parseInt(event.target.value)
    this.props.knowsHowMuchToInvestSelected(knowsHowMuchToInvestOptionId)

    if (knowsHowMuchToInvestOptionId === 2) {
      let monthlyInvestmentAmount = 0
      this.props.monthlyInvestmentAmountSelected(monthlyInvestmentAmount)

      let onceOffInvestmentAmount = 0
      this.props.onceOffInvestmentAmountSelected(onceOffInvestmentAmount)
    }
  }

  onMonthlyChanged = (event) => {
    const parsed = parseInt(event.target.value, 10)
    // Default empty/invalid to 0 and clamp negatives to 0 - no negative or NaN amounts.
    this.props.monthlyInvestmentAmountSelected(isNaN(parsed) ? 0 : Math.max(0, parsed))
  }

  onOnceOffChanged = (event) => {
    const parsed = parseInt(event.target.value, 10)
    this.props.onceOffInvestmentAmountSelected(isNaN(parsed) ? 0 : Math.max(0, parsed))
  }

  onChange (event) {
    this.props.onChange(event.target.value)
  }

  toggleEditingMonthlyInvestment () {
    this.setState({ isEditingMonthlyInvestment: !this.state.isEditingMonthlyInvestment })
  }

  toggleEditingOnceOffInvestment () {
    this.setState({ isEditingOnceOffInvestment: !this.state.isEditingOnceOffInvestment })
  }

  render () {
    // Guard against undefined props during hydration
    if (!this.props.knowsHowMuchToInvestOptions) {
      return null
    }

    const selectedKnowsHowMuchToInvestOptionId = this.props.selectedKnowsHowMuchToInvestOptionId

    const knowsHowMuchToInvestOptions = this.props.knowsHowMuchToInvestOptions.map(option => ({
      ...option,
      checked: option.knowsHowMuchToInvestOptionId === selectedKnowsHowMuchToInvestOptionId
    }))

    const showInvestmentInputs = selectedKnowsHowMuchToInvestOptionId === 1

    let monthlyInvestmentInput = null
    let onceOffInvestmentInput = null

    if (showInvestmentInputs) {
      monthlyInvestmentInput = <Col xs={12} sm={{ span: 3, offset: 2 }} md={{ span: 2, offset: 3 }} lg={{ span: 2, offset: 3 }}>
        {this.state.isEditingMonthlyInvestment ? (
          <FieldGroup
            label={'Monthly investment'}
            type={'number'}
            prefix={'R'}
            placeholder={'Amount'}
            value={this.props.investmentAmounts.monthlyAmount || ''}
            onChange={this.onMonthlyChanged}
            onWheel={event => { event.preventDefault() }}
            onBlur={this.toggleEditingMonthlyInvestment}
           />
      ) : (
        <FieldGroup
          label={'Monthly investment'}
          type={'text'}
          prefix={'R'}
          placeholder={'Amount'}
          value={inputFormatToRands(this.props.investmentAmounts.monthlyAmount)}
          onChange={() => {}}
          onWheel={event => {}}
          onFocus={this.toggleEditingMonthlyInvestment}
          />
      )}
      </Col>
    }

    if (showInvestmentInputs) {
      onceOffInvestmentInput = <Col xs={12} sm={{ span: 3, offset: 1 }} md={{ span: 2, offset: 1 }} lg={{ span: 2, offset: 1}}>
        {this.state.isEditingOnceOffInvestment ? (
          <FieldGroup
            label={'Once-off investment'}
            type={'number'}
            prefix={'R'}
            placeholder={'Amount'}
            value={this.props.investmentAmounts.onceOffAmount || ''}
            onChange={this.onOnceOffChanged}
            onWheel={event => { event.preventDefault() }}
            onBlur={this.toggleEditingOnceOffInvestment}
           />
      ) : (
        <FieldGroup
          label={'Once-off investment'}
          type={'text'}
          prefix={'R'}
          placeholder={'Amount'}
          value={inputFormatToRands(this.props.investmentAmounts.onceOffAmount)}
          onChange={() => {}}
          onWheel={event => {}}
          onFocus={this.toggleEditingOnceOffInvestment}
          />
      )}
      </Col>
    }

    return (
      <Row className={commonStyles['bg-grey']}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <section className={styles['investment-amount-section']} id={'investmentAmountContainer'} >
            <h3>Do you know how much you would like to invest?</h3>
            {this.props.showValidationErrors &&
              this.props.validation.help &&
              <Form.Text className={helpBlockStyles}>
                {this.props.validation.help}
              </Form.Text>}
            <Form.Group>
              <ResponsiveInputsList
                list={knowsHowMuchToInvestOptions}
                renderFunction={this.renderKnowsHowMuchToInvestmentOptionRadioButton} />
            </Form.Group>
            {showInvestmentInputs && <p className={styles['investment-options-description']}>You can choose to invest a <strong>monthly</strong> investment amount, a <strong>once-off</strong> investment amount, or <strong>both</strong>.</p>}
            {showInvestmentInputs && <Row>
              {monthlyInvestmentInput}
              {onceOffInvestmentInput}
            </Row>}
          </section>
        </Col>
      </Row>
    )
  }

  renderKnowsHowMuchToInvestmentOptionRadioButton ({ knowsHowMuchToInvestOptionId, option, checked }) {
    return <Form.Check 
      type='radio'
      name='knowsHowMuchToInvestmentOption'
      key={knowsHowMuchToInvestOptionId}
      defaultChecked={checked}
      value={knowsHowMuchToInvestOptionId}
      onChange={this.onKnowsHowMuchToInvestOptionStateChange}
      isInvalid={this.props.showValidationErrors && this.props.validation?.isInvalid}
      label={
        <>
        <span>{option}</span>
        </>
      }>
      
    </Form.Check>
  }
}

export default (InvestmentAmount)
